import TomSelect from 'tom-select';

export default function classicSelect(elSelect: string = '.supay-select-classic') {
    
    document.querySelectorAll(elSelect).forEach((el)=>{
    
        let item = el.id;

        if(item != null){

            new TomSelect('#' + item, {
                plugins: ['dropdown_input'],
                allowEmptyOption: true,
                persist: false,
                render: {
                    option: function (item, escape) {
                        return '<span class="block w-full fluid-text-xs">'+ escape(item.text) +'</span>';
                    },
                    item: function (item, escape) {
                        return '<span>'+ escape(item.text) +'</span>';
                    },
                }
            });
            
        }
        
    });

}